import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import { ReactComponent as RakennusliittoLogo } from 'Assets/Rakennusliitto_logo_vaaka_FI_valkoinen_RGB.svg';

const FooterContainer = styled.footer`
  min-height: 221px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #d6dce2;
  font-family: acumin-pro;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  background-color: #1E1E1E;
  color: #fff;
  width: 100%;
  position: relative;
  overflow: hidden;
  .container {
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 6.4rem 2rem;
  }
  .wrapper {
    display: flex;
    margin-top: 1rem;
    flex-direction: column;
    @media screen and ${(props) => props.theme.breakpoints.lg} {
      flex-direction: row;
      > div,
      ul {
        width: 25%;
      }
    }
  }
  ul {
    list-style: none;
    padding-left: 0;
  }
  p {
    font-size: 17px;
    line-height: 1.8;
    font-weight: 100;
  }
  .logo {
    margin: 0;
  }
  .social-media-icons {
    display: flex;
    border-bottom: 1px solid #bebebe;
    li {
      margin-right: 1.5rem;
      a {
        svg path {
          transition: all 0.33s;
          fill: #fff;
        }
        &:hover {
          svg path {
            fill: #aa2128;
          }
        }
      }
    }
  }
  a {
    color: #fff;
    font-weight: 100;
    text-decoration: none;
    &:hover {
      color: #fff;
      text-decoration: underline;
    }
    &.button {
      display: inline-flex;
      align-items: center;
      padding: 10px 20px;
      text-decoration: none;
      font-weight: 400;
      transition: all 0.33s;
      font-size: 14px;
      border-radius: 8px;
      background-color: transparent;
      border: 2px solid #fff;
      color: #fff;
      svg {
        color: #fff;
        fill: #fff;
        margin-right: 5px;
      }
    }
  }
  strong {
    font-weight: bolder;
  }
  .footer-links {
    a {
      font-weight: 600;
      line-height: 1.7;
      svg {
        transform: rotate(-90deg);
        fill: #fff;
      }
    }
  }
  .footer-buttons li {
    margin-bottom: 1rem;
    a {
      font-family: 'Source Code Pro';
    }
    a:hover {
      background-color: #3c3c3c;
      border: 2px solid #fff;
    }
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <div className="container">
        <figure className="logo">
          <RakennusliittoLogo width={170} height={50} />
        </figure>

        <div className="wrapper wrapper-grid-4">
          <ul className="footer-buttons">
            <li>
              <a
                href="https://rakennusliitto.fi/"
                className="button button-gray button-transparent"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  width="13"
                  height="13"
                >
                  <path d="M14 16V5l-1 1v9H1V3h9l1-1H0v14h14z" />
                  <path d="M16 0h-5l1.8 1.8L6 8.6 7.4 10l6.8-6.8L16 5V0z" />
                </svg>
                Rakennusliitto
              </a>
            </li>
          </ul>
        </div>
        <ul className="social-media-icons" />
        <ul className="other-links">
          <li>
            <a href="https://rakennusliitto.fi/rakennusliitto/tietosuoja/">
              Tietosuoja
            </a>
          </li>
        </ul>
      </div>
    </FooterContainer>
  );
};

export default Footer;
